export default __webpack_public_path__ + "img/pin_icons/building_pin-selected.svg";